<template>
    <div class="amenity-cards">
        <amenity-card :key="item.id" :item="item" v-for="item in items"></amenity-card>
    </div>
</template>

<script>
    export default {
        props: ['items'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {},
        watch: {}
    }
</script>
